import api from "./api";

class LeadService{
    getListUser(idItem){
        return api
            .get("/user/list?id="+idItem)
            .then((response) => {
                return response;
            });
    }
    getDataPage(data){
        return api
            .get("/lead/paginate",{
                params: data
              })
            .then((response) => {
                return response;
            });
    }
    changeStatusContact(item,valueStatus) {
        if (Array.isArray(item)) {
            return api
                .post("/lead/approve-all",{
                    ids: item ,
                    valueStatus: valueStatus ,
                })
                .then((response) => {
                    return response;
                });
        } else if (typeof item === 'object' && item !== null  && item.id) {
            return api
            .put("/lead/"+item.id, item)
            .then((response) => {
                return response;
            });
        }
    }
    
    destroy(data) {
        if (Array.isArray(data)) {
            return api
                .post("/lead/del-all",{
                    ids: data 
                })
                .then((response) => {
                    return response;
                });
        } else if ( data !== null ) {
            return api
                .delete("/lead/"+data)
                .then((response) => {
                    return response;
                });
        }
    }
    
    getItem(id){
        return api
            .get("/lead/"+id)
            .then((response) => {
                return response;
            });
    }
    updateOrCreate(item) {
        if(item.id){
            return api
                .put("/lead/"+item.id, item)
                .then((response) => {
                    return response;
                });
        }
        return api
            .post("/lead", item)
            .then((response) => {
                return response;
            });
    }
   
}

export default new LeadService();